import { render } from "./AnnualPerformance.vue?vue&type=template&id=f2e21a18&scoped=true"
import script from "./AnnualPerformance.vue?vue&type=script&lang=js"
export * from "./AnnualPerformance.vue?vue&type=script&lang=js"

import "./AnnualPerformance.vue?vue&type=style&index=0&id=f2e21a18&scoped=true&lang=css"

import exportComponent from "C:\\Users\\lenovo\\Desktop\\canadianlic\\client\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2e21a18"]])

export default __exports__